var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoodCheckinIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.3759 7.25094C54.3759 5.24812 52.7501 3.61325 50.7546 3.75462C38.5779 4.62822 27.1234 9.85874 18.4884 18.4884C9.85874 27.1234 4.62822 38.5779 3.75462 50.7546C3.61325 52.7501 5.24812 54.3759 7.25094 54.3759C7.25094 54.3759 8.35656 54.4086 9.06344 54.3759C12.6884 38.9697 13.8484 32.6441 22.3309 24.1434C30.8316 15.6428 42.5947 10.8759 54.3759 9.06344V7.25094Z",
    fill: "#F8312F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.375 14.5V9.0625C48.4241 9.06139 42.5312 10.2325 37.0329 12.509C31.5346 14.7854 26.5385 18.1226 22.33 22.33C13.8395 30.834 9.06821 42.3581 9.0625 54.375H14.5C16.3125 47.125 20.5175 35.4706 27.985 27.985C35.4525 20.5175 42.5938 17.2188 54.375 14.5Z",
    fill: "#FFB02E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.375 14.5V19.9375C45.3125 20.8438 38.28 25.375 31.8275 31.8275C25.375 38.2981 21.75 45.3125 19.9375 54.375H14.5C14.5 43.8081 18.705 33.6581 26.1725 26.1725C29.8766 22.4702 34.2737 19.5338 39.1127 17.531C43.9517 15.5282 49.1379 14.4983 54.375 14.5Z",
    fill: "#FFF478"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6881 35.6881C30.2506 41.1256 27.1875 47.125 25.375 54.375H19.9375C19.9375 45.24 23.5625 36.4856 30.015 30.015C36.4675 23.5625 45.24 19.9375 54.375 19.9375V25.375C46.2188 27.1875 41.1256 30.2506 35.6881 35.6881Z",
    fill: "#00D26A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.375 30.8125V25.375C46.69 25.375 39.3131 28.4381 33.8756 33.8756C28.4381 39.3131 25.375 46.69 25.375 54.375H30.8125C30.8125 48.1219 33.2956 42.1225 37.7181 37.7181C42.1406 33.2956 48.14 30.8125 54.375 30.8125Z",
    fill: "#3F5FFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.375 32.625C54.375 34.6278 52.7365 36.2137 50.7736 36.6089C47.2827 37.3186 44.078 39.0402 41.5591 41.5591C39.0402 44.078 37.3186 47.2827 36.6089 50.7736C36.2119 52.7347 34.6278 54.375 32.625 54.375H30.8125C30.8125 48.1219 33.2956 42.1225 37.7181 37.7181C42.1406 33.2956 48.14 30.8125 54.375 30.8125V32.625Z",
    fill: "#8D65C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodCheckinIndicator);
export default __webpack_public_path__ + "static/media/mood-checkin_indicator.ada362bae6b05deeef0da8e10dce2e25.svg";
export { ForwardRef as ReactComponent };